import {
   Skeleton as MantineSkeleton,
   SkeletonProps as MantineSkeletonProps,
} from '@mantine/core'

export const Skeleton = ({ ...props }: MantineSkeletonProps) => {
   return (
      <MantineSkeleton
         {...props}
      />
   )
}
